import React from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@ohif/ui-next';

type ConfirmLogoutModalProps = {
  hide?: () => void;
  onConfirm: () => void;
};

export default function ConfirmLogoutModal({ hide, onConfirm }: ConfirmLogoutModalProps) {
  const { t } = useTranslation();

  return (
    <div className="space-y-5">
      <div className="text-primary-light text-base">
        {t('Header:Are you sure you want to logout?')}
      </div>
      <div className="flex justify-end gap-2">
        <Button
          variant="secondary"
          onClick={() => hide?.()}
        >
          {t('Buttons:Cancel')}
        </Button>
        <Button
          variant="default"
          onClick={() => {
            hide?.();
            onConfirm();
          }}
        >
          {t('Buttons:Continue')}
        </Button>
      </div>
    </div>
  );
}

